import { useState } from 'react'
import { ChevronIcon } from 'components/Global/ChevronIcon'
import { CloseIcon } from 'components/Global/CloseIcon'

export const ProductReviewFilter = ({
  label,
  values,
  filter,
  setFilter,
  activeFilter,
  open = false,
  setOpen,
}) => {
  const handleFilterClick = (value) => {
    setOpen(null)
    setFilter(filter, value)
  }

  return (
    <div className="relative text-[10px] md:text-12">
      <button
        className="relative z-[3] flex cursor-pointer items-center gap-4 uppercase"
        aria-expanded={open}
        onClick={() => setOpen(open ? null : filter)}
      >
        <span className="py-4">{label}</span>
        {!activeFilter ? (
          <div
            className={`${
              open ? '-rotate-180' : 'rotate-0'
            } ease transition transition-transform duration-300`}
          >
            <ChevronIcon />
          </div>
        ) : (
          <button
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setFilter(filter, null)
            }}
            className="ml-2 flex items-center gap-4 rounded-10 bg-[#DEDEDE] px-[5px] py-2 text-10 uppercase md:ml-4 md:px-6 md:py-4"
          >
            {activeFilter}{' '}
            <CloseIcon className="mr-[1px] h-8 w-8 md:mr-2" fill="#5E5E5E" />{' '}
          </button>
        )}
      </button>
      {open ? (
        <div className="absolute -left-10 -top-10 z-[2] flex w-[calc(100%+20px)] min-w-[85px] flex-col items-start gap-4 rounded-10 bg-[#F5F5F7] px-8 pb-10 pt-40 shadow-md">
          {values.map((value) => {
            if (value !== activeFilter) {
              return (
                <button
                  key={`${filter}-${value}`}
                  className="ease block rounded-6 p-4 uppercase transition transition-colors duration-200 md:hover:bg-[#DEDEDE]"
                  onClick={() => handleFilterClick(value)}
                >
                  {value} {filter === 'rating' ? 'Stars' : ''}
                </button>
              )
            }

            return (
              <button
                key={`${filter}-${value}`}
                className="ease flex items-center gap-4 rounded-6 bg-[#DEDEDE] p-4 uppercase transition transition-colors duration-200"
                onClick={() => handleFilterClick(null)}
              >
                {value} {filter === 'rating' ? 'Stars' : ''}{' '}
                <CloseIcon className="mr-2 h-8 w-8" fill="#5E5E5E" />
              </button>
            )
          })}
        </div>
      ) : null}
    </div>
  )
}
